export const billingCodeDisplayIds = {
    unitReplacementFullBuyOut: "U002"
}

export const authorizationStatus = {
    approved: 1,
    partiallyApproved: 2,
    denied: 3
}